import { GridApi } from 'ag-grid-community';
import { HrLinkedUserSelect, HrPersonSelect, HrTermTypeSelect } from 'components/selects/hr/HrSelects';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

interface HrEntitySelectFilterProps {
  api: GridApi;
  onChange?: FilterChangeCallback;
}

/** Permission-scoped person floating filter for HR tables. */
export function HrPersonSelectFilter({ api, onChange }: HrEntitySelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: 'personId', onChange });
  return (
    <HrPersonSelect
      lazyLoad
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky osoby"
      value={value}
      onChange={setValue}
    />
  );
}

/** Permission-scoped linked-user floating filter for the people table. */
export function HrLinkedUserSelectFilter({ api, onChange }: HrEntitySelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: 'linkedUserId', onChange });
  return (
    <HrLinkedUserSelect
      lazyLoad
      clearable
      w="100%"
      size="sm"
      placeholder="Používateľ"
      value={value}
      onChange={setValue}
    />
  );
}

/** Permission-scoped term-type floating filter for the global terms table. */
export function HrTermTypeSelectFilter({ api, onChange }: HrEntitySelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: 'termTypeId', onChange });
  return (
    <HrTermTypeSelect
      lazyLoad
      clearable
      w="100%"
      size="sm"
      placeholder="Typ termínu"
      value={value}
      onChange={setValue}
    />
  );
}
